import { z } from 'zod';
import { IdSchema } from './base.schema';
import { JobTypeSchema, JobStatusSchema } from './enums.schema';

/**
 * Job Processing Schema
 * Core job execution and management
 */

// Job Schema
export const JobSchema = z.object({
  id: IdSchema,
  type: JobTypeSchema,
  status: JobStatusSchema,
  input: z.record(z.string(), z.unknown()),
  output: z.record(z.string(), z.unknown()).optional(),
  error: z.string().optional(),
  // An exact decimal string, matching what the job routes put on the wire: the column is
  // Decimal(18,8) and a float cannot hold every value it can (0.002 among them).
  creditsUsed: z.string().regex(/^\d+(\.\d+)?$/, 'must be a decimal amount').default('0'),
  executionTime: z.number().int().min(0).optional(),
  nodeId: z.string().optional(),
  priority: z.number().int().default(0),
  retryCount: z.number().int().min(0).default(0),
  maxRetries: z.number().int().min(0).default(3),
  startedAt: z.date().optional(),
  completedAt: z.date().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: IdSchema,
  canvasId: IdSchema
});

// Export TypeScript types
export type Job = z.infer<typeof JobSchema>;